<div
  class="my-3 flex items-center gap-3 text-sm font-bold uppercase text-white/70"
>
  <span class="h-px flex-1 bg-white/20"></span>
  <span>{{ "OR" | translate }}</span>
  <span class="h-px flex-1 bg-white/20"></span>
</div>

<div class="grid gap-3">
  <button
    type="button"
    class="btn btn-white full flex! h-[58px]! items-center justify-center gap-3 py-0! text-[16px]! mobile:text-m! disabled:cursor-not-allowed disabled:opacity-60"
    [disabled]="disabled || !!loadingProvider"
    (click)="onSocialLogin('google')"
  >
    <img
      src="/assets/images/icons/logo-google.svg"
      alt=""
      aria-hidden="true"
      class="h-4 w-4 shrink-0"
    />
    {{
      loadingProvider === "google"
        ? ("LOGGING_IN" | translate)
        : ("CONTINUE_WITH_GOOGLE" | translate)
    }}
  </button>

  <button
    type="button"
    class="btn btn-white full flex! h-[58px]! items-center justify-center gap-3 py-0! text-[16px]! mobile:text-m! disabled:cursor-not-allowed disabled:opacity-60"
    [disabled]="disabled || !!loadingProvider"
    (click)="onSocialLogin('apple')"
  >
    <img
      src="/assets/images/icons/logo-apple.svg"
      alt=""
      aria-hidden="true"
      class="h-4 w-4 shrink-0"
    />
    {{
      loadingProvider === "apple"
        ? ("LOGGING_IN" | translate)
        : ("CONTINUE_WITH_APPLE" | translate)
    }}
  </button>
</div>

@if (errorMessageKey) {
<div class="mt-3 text-left text-sm text-white" role="alert">
  <p>{{ errorMessageKey | translate }}</p>
  @if (errorMessageKey !== 'SOCIAL_AUTH_CANCELLED') {
  <a
    href="mailto:hello@gemster.io"
    class="mt-2 inline-block underline decoration-dotted"
    >{{ "SOCIAL_AUTH_CONTACT_SUPPORT" | translate }}</a
  >
  }
</div>
}
